import gurgaonImg from "../assets/Gurgaon_image.jpeg";
import noidaImg from "../assets/Noida.png";
import backgroundImg from "../assets/locations-bg.jpeg";

import { Link } from "react-router-dom";
import '../styles/Locations.css';
import Seo from './Seo';

export default function Locations() {

  return (
    <div className="page-locations">
      <Seo
        path="/locations"
        title="Mystery Mansion Locations | Gurugram & Greater Noida"
        description="Explore Mystery Mansion locations in Gurugram and Greater Noida and choose a villa for your group's immersive mystery staycation experience."
      />

    <div className="bg-black min-h-screen flex flex-col items-center py-16" style={{
          backgroundImage: `url(${backgroundImg})`,
          filter: 'brightness(1.2)'
    }}>

      <div className="flex flex-wrap justify-center gap-12">
        {/* Gurgaon Card */}
        <div className="rounded-lg shadow-lg overflow-hidden w-[380px] transform transition duration-300 hover:scale-105" style={{backgroundColor: '#E8E3E3'}}>
        <div className="p-4" style={{backgroundColor: '#E8E3E3'}}>
        <img src={gurgaonImg} alt="Gurgaon" className="w-full h-96 object-cover" style = {{objectPosition:'42% center'}}/>
      </div>
      <div className="p-4 min-h-[150px] relative right-0">
          <h2 className="text-4xl font-semibold text-black force-black">
          {"Gurugram".split('').map((letter, index) => (
              <span key={index} className="wavy-letter">
                {letter === ' ' ? '\u00A0' : letter}
              </span>
            ))}
          
        </h2>
    
      
    
        {/* Button with proper spacing */}
        <div className="mt-10"> {/* Add margin to avoid overlap */}
          <Link to="/gurugram">
          <button className="bg-gray-700 px-8 py-3 rounded-full hover:bg-gray-900 transition-colors duration-300 relative z-10 text-xl left-1 text-gray-400">
            Book Now
          </button>
          </Link>
        </div>
      </div>
    </div>

        {/* Greater Noida Card */}
        <div className="rounded-lg shadow-lg overflow-hidden w-[380px] transform transition duration-300 hover:scale-105" style={{backgroundColor: '#E8E3E3'}}>
          <div className="p-4" style={{backgroundColor: '#E8E3E3'}}>
          <img src={noidaImg} alt="Greater Noida" className="w-full h-96 object-cover" />
          </div>
          <div className="p-4 min-h-[150px] relative right-0">
            <h2 className="text-4xl font-semibold text-black force-black" style = {{transform: "translate(0px, 0px)"}}>
              {"Greater Noida".split('').map((letter, index) => (
              <span key={index} className="wavy-letter">
                {letter === ' ' ? '\u00A0' : letter}
              </span>
            ))}
              
              </h2>

        {/* Button with proper spacing */}
        <div className="mt-10"> {/* Add margin to avoid overlap */}
          <Link to="/greater-noida">
          <button className="bg-gray-700 px-8 py-3 rounded-full hover:bg-gray-900 transition-colors duration-300 relative z-10 text-xl left-1 text-gray-400">
            Book Now
          </button>
          </Link>
        </div>
          </div>
        </div>
      </div>
    </div>
    </div>
  );
}